import {Component, NgZone, OnInit} from '@angular/core';

import {AccountService} from '../../_services/account.service';
import {Persona} from '../../_models/persona';
import {AuthenticationService} from '../../_services';
import {Router} from '@angular/router';

@Component({
  selector: 'user-menu',
  standalone: false,
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user.component.scss'],
  providers: []
})
export class UserMenuComponent implements OnInit {
  private showMenu: boolean;

  public currUser: Persona;
  public userImage = false;


  constructor(private zone: NgZone,
              private accs: AccountService,
              private authenticationService: AuthenticationService,
              private router: Router) {
  }

  menuState(estado) {
    this.showMenu = estado;
  }

  ngOnInit() {
    const userData = this.accs.getUser();
    this.showMenu = false;

    if (userData) {
      this.processUser(userData);
    } else {
      this.accs.getPersona().subscribe((per) => {
        this.processUser(this.accs.extractData(per));
        this.accs.setUser(this.currUser);
      });
    }
  }

  processUser(persona) {
    const objImg = new Image(),
      that = this;
    objImg.src = persona['imageUrl'];
    objImg.onload = function () {
      that.userImage = true;
    };
    this.currUser = new Persona(persona);
  }

  logout() {
    this.authenticationService.logout().subscribe(() => {
      this.authenticationService.clearSession();
      this.accs.destroyUserSession();
      this.router.navigate(['./login']);
    });
  }
}
